import request from "../../utils/fetch";

export const sendNotificationsData = (postData) => request.post(`subscription/notification`, postData);


